export const componentsArray = [
  {
    id: 'wordpress-plugin',
    name: 'plugin',
    label: 'WordPress plugin'
  },
  {
    id: 'wordpress-theme',
    name: 'theme',
    label: 'WordPress theme'
  },
  {
    id: 'wordpress-core',
    name: 'core',
    label: 'WordPress core'
  }
];

export const userRolesArray = [
  {
    id: 'unauthenticated',
    name: 'Unauthenticated',
    label: 'Unauthenticated',
    value: '1'
  },
  {
    id: 'subscriber',
    name: 'Subscriber',
    label: 'Subscriber',
    value: '2'
  },
  {
    id: 'contributor',
    name: 'Contributor',
    label: 'Contributor',
    value: '3'
  },
  {
    id: 'author',
    name: 'Author',
    label: 'Author',
    value: '4'
  },
  {
    id: 'editor',
    name: 'Editor',
    label: 'Editor',
    value: '5'
  },
  {
    id: 'administrator',
    name: 'Administrator',
    label: 'Administrator',
    value: '6'
  },
  {
    id: 'super-admin',
    name: 'Super admin',
    label: 'Super admin',
    value: '7'
  },
  {
    id: 'shop-manager',
    name: 'Shop manager',
    label: 'Shop manager',
    value: '8'
  },
  {
    id: 'customer',
    name: 'Customer',
    label: 'Customer',
    value: '9'
  }
];

export const plansArray = [
  { id: 'free', name: 'Free', label: 'Free' },
  { id: 'premium', name: 'Premium', label: 'Paid' },
  { id: 'both', name: 'Both', label: 'Both' }
];

export const softwareTypesArray = [
  { id: 'plugin', name: 'Plugin', label: 'Plugin' },
  { id: 'theme', name: 'Theme', label: 'Theme' }
];

export const countryList = [
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AL', label: 'Albania' },
  { value: 'DZ', label: 'Algeria' },
  { value: 'AS', label: 'American Samoa' },
  { value: 'AD', label: 'Andorra' },
  { value: 'AO', label: 'Angola' },
  { value: 'AI', label: 'Anguilla' },
  { value: 'AQ', label: 'Antarctica' },
  { value: 'AG', label: 'Antigua and Barbuda' },
  { value: 'AR', label: 'Argentina' },
  { value: 'AM', label: 'Armenia' },
  { value: 'AW', label: 'Aruba' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'AZ', label: 'Azerbaijan' },
  { value: 'BS', label: 'Bahamas (the)' },
  { value: 'BH', label: 'Bahrain' },
  { value: 'BD', label: 'Bangladesh' },
  { value: 'BB', label: 'Barbados' },
  { value: 'BY', label: 'Belarus' },
  { value: 'BE', label: 'Belgium' },
  { value: 'BZ', label: 'Belize' },
  { value: 'BJ', label: 'Benin' },
  { value: 'BM', label: 'Bermuda' },
  { value: 'BT', label: 'Bhutan' },
  { value: 'BO', label: 'Bolivia (Plurinational State of)' },
  { value: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', label: 'Bosnia and Herzegovina' },
  { value: 'BW', label: 'Botswana' },
  { value: 'BV', label: 'Bouvet Island' },
  { value: 'BR', label: 'Brazil' },
  { value: 'IO', label: 'British Indian Ocean Territory (the)' },
  { value: 'BN', label: 'Brunei Darussalam' },
  { value: 'BG', label: 'Bulgaria' },
  { value: 'BF', label: 'Burkina Faso' },
  { value: 'BI', label: 'Burundi' },
  { value: 'CV', label: 'Cabo Verde' },
  { value: 'KH', label: 'Cambodia' },
  { value: 'CM', label: 'Cameroon' },
  { value: 'CA', label: 'Canada' },
  { value: 'KY', label: 'Cayman Islands (the)' },
  { value: 'CF', label: 'Central African Republic (the)' },
  { value: 'TD', label: 'Chad' },
  { value: 'CL', label: 'Chile' },
  { value: 'CN', label: 'China' },
  { value: 'CX', label: 'Christmas Island' },
  { value: 'CC', label: 'Cocos (Keeling) Islands (the)' },
  { value: 'CO', label: 'Colombia' },
  { value: 'KM', label: 'Comoros (the)' },
  { value: 'CD', label: 'Congo (the Democratic Republic of the)' },
  { value: 'CG', label: 'Congo (the)' },
  { value: 'CK', label: 'Cook Islands (the)' },
  { value: 'CR', label: 'Costa Rica' },
  { value: 'HR', label: 'Croatia' },
  { value: 'CU', label: 'Cuba' },
  { value: 'CW', label: 'Curaçao' },
  { value: 'CY', label: 'Cyprus' },
  { value: 'CZ', label: 'Czechia' },
  { value: 'CI', label: "Côte d'Ivoire" },
  { value: 'DK', label: 'Denmark' },
  { value: 'DJ', label: 'Djibouti' },
  { value: 'DM', label: 'Dominica' },
  { value: 'DO', label: 'Dominican Republic (the)' },
  { value: 'EC', label: 'Ecuador' },
  { value: 'EG', label: 'Egypt' },
  { value: 'SV', label: 'El Salvador' },
  { value: 'GQ', label: 'Equatorial Guinea' },
  { value: 'ER', label: 'Eritrea' },
  { value: 'EE', label: 'Estonia' },
  { value: 'SZ', label: 'Eswatini' },
  { value: 'ET', label: 'Ethiopia' },
  { value: 'FK', label: 'Falkland Islands (the) [Malvinas]' },
  { value: 'FO', label: 'Faroe Islands (the)' },
  { value: 'FJ', label: 'Fiji' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'GF', label: 'French Guiana' },
  { value: 'PF', label: 'French Polynesia' },
  { value: 'TF', label: 'French Southern Territories (the)' },
  { value: 'GA', label: 'Gabon' },
  { value: 'GM', label: 'Gambia (the)' },
  { value: 'GE', label: 'Georgia' },
  { value: 'DE', label: 'Germany' },
  { value: 'GH', label: 'Ghana' },
  { value: 'GI', label: 'Gibraltar' },
  { value: 'GR', label: 'Greece' },
  { value: 'GL', label: 'Greenland' },
  { value: 'GD', label: 'Grenada' },
  { value: 'GP', label: 'Guadeloupe' },
  { value: 'GU', label: 'Guam' },
  { value: 'GT', label: 'Guatemala' },
  { value: 'GG', label: 'Guernsey' },
  { value: 'GN', label: 'Guinea' },
  { value: 'GW', label: 'Guinea-Bissau' },
  { value: 'GY', label: 'Guyana' },
  { value: 'HT', label: 'Haiti' },
  { value: 'HM', label: 'Heard Island and McDonald Islands' },
  { value: 'VA', label: 'Holy See (the)' },
  { value: 'HN', label: 'Honduras' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'HU', label: 'Hungary' },
  { value: 'IS', label: 'Iceland' },
  { value: 'IN', label: 'India' },
  { value: 'ID', label: 'Indonesia' },
  { value: 'IR', label: 'Iran (Islamic Republic of)' },
  { value: 'IQ', label: 'Iraq' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IM', label: 'Isle of Man' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JM', label: 'Jamaica' },
  { value: 'JP', label: 'Japan' },
  { value: 'JE', label: 'Jersey' },
  { value: 'JO', label: 'Jordan' },
  { value: 'KZ', label: 'Kazakhstan' },
  { value: 'KE', label: 'Kenya' },
  { value: 'KI', label: 'Kiribati' },
  { value: 'KP', label: "Korea (the Democratic People's Republic of)" },
  { value: 'KR', label: 'Korea (the Republic of)' },
  { value: 'KW', label: 'Kuwait' },
  { value: 'KG', label: 'Kyrgyzstan' },
  { value: 'LA', label: "Lao People's Democratic Republic (the)" },
  { value: 'LV', label: 'Latvia' },
  { value: 'LB', label: 'Lebanon' },
  { value: 'LS', label: 'Lesotho' },
  { value: 'LR', label: 'Liberia' },
  { value: 'LY', label: 'Libya' },
  { value: 'LI', label: 'Liechtenstein' },
  { value: 'LT', label: 'Lithuania' },
  { value: 'LU', label: 'Luxembourg' },
  { value: 'MO', label: 'Macao' },
  { value: 'MG', label: 'Madagascar' },
  { value: 'MW', label: 'Malawi' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'MV', label: 'Maldives' },
  { value: 'ML', label: 'Mali' },
  { value: 'MT', label: 'Malta' },
  { value: 'MH', label: 'Marshall Islands (the)' },
  { value: 'MQ', label: 'Martinique' },
  { value: 'MR', label: 'Mauritania' },
  { value: 'MU', label: 'Mauritius' },
  { value: 'YT', label: 'Mayotte' },
  { value: 'MX', label: 'Mexico' },
  { value: 'FM', label: 'Micronesia (Federated States of)' },
  { value: 'MD', label: 'Moldova (the Republic of)' },
  { value: 'MC', label: 'Monaco' },
  { value: 'MN', label: 'Mongolia' },
  { value: 'ME', label: 'Montenegro' },
  { value: 'MS', label: 'Montserrat' },
  { value: 'MA', label: 'Morocco' },
  { value: 'MZ', label: 'Mozambique' },
  { value: 'MM', label: 'Myanmar' },
  { value: 'NA', label: 'Namibia' },
  { value: 'NR', label: 'Nauru' },
  { value: 'NP', label: 'Nepal' },
  { value: 'NL', label: 'Netherlands (the)' },
  { value: 'NC', label: 'New Caledonia' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NI', label: 'Nicaragua' },
  { value: 'NE', label: 'Niger (the)' },
  { value: 'NG', label: 'Nigeria' },
  { value: 'NU', label: 'Niue' },
  { value: 'NF', label: 'Norfolk Island' },
  { value: 'MP', label: 'Northern Mariana Islands (the)' },
  { value: 'NO', label: 'Norway' },
  { value: 'OM', label: 'Oman' },
  { value: 'PK', label: 'Pakistan' },
  { value: 'PW', label: 'Palau' },
  { value: 'PS', label: 'Palestine, State of' },
  { value: 'PA', label: 'Panama' },
  { value: 'PG', label: 'Papua New Guinea' },
  { value: 'PY', label: 'Paraguay' },
  { value: 'PE', label: 'Peru' },
  { value: 'PH', label: 'Philippines (the)' },
  { value: 'PN', label: 'Pitcairn' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'PR', label: 'Puerto Rico' },
  { value: 'QA', label: 'Qatar' },
  { value: 'MK', label: 'Republic of North Macedonia' },
  { value: 'RO', label: 'Romania' },
  { value: 'RU', label: 'Russian Federation (the)' },
  { value: 'RW', label: 'Rwanda' },
  { value: 'RE', label: 'Réunion' },
  { value: 'BL', label: 'Saint Barthélemy' },
  { value: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', label: 'Saint Kitts and Nevis' },
  { value: 'LC', label: 'Saint Lucia' },
  { value: 'MF', label: 'Saint Martin (French part)' },
  { value: 'PM', label: 'Saint Pierre and Miquelon' },
  { value: 'VC', label: 'Saint Vincent and the Grenadines' },
  { value: 'WS', label: 'Samoa' },
  { value: 'SM', label: 'San Marino' },
  { value: 'ST', label: 'Sao Tome and Principe' },
  { value: 'SA', label: 'Saudi Arabia' },
  { value: 'SN', label: 'Senegal' },
  { value: 'RS', label: 'Serbia' },
  { value: 'SC', label: 'Seychelles' },
  { value: 'SL', label: 'Sierra Leone' },
  { value: 'SG', label: 'Singapore' },
  { value: 'SX', label: 'Sint Maarten (Dutch part)' },
  { value: 'SK', label: 'Slovakia' },
  { value: 'SI', label: 'Slovenia' },
  { value: 'SB', label: 'Solomon Islands' },
  { value: 'SO', label: 'Somalia' },
  { value: 'ZA', label: 'South Africa' },
  { value: 'GS', label: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', label: 'South Sudan' },
  { value: 'ES', label: 'Spain' },
  { value: 'LK', label: 'Sri Lanka' },
  { value: 'SD', label: 'Sudan (the)' },
  { value: 'SR', label: 'Suriname' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'SY', label: 'Syrian Arab Republic' },
  { value: 'TW', label: 'Taiwan' },
  { value: 'TJ', label: 'Tajikistan' },
  { value: 'TZ', label: 'Tanzania, United Republic of' },
  { value: 'TH', label: 'Thailand' },
  { value: 'TL', label: 'Timor-Leste' },
  { value: 'TG', label: 'Togo' },
  { value: 'TK', label: 'Tokelau' },
  { value: 'TO', label: 'Tonga' },
  { value: 'TT', label: 'Trinidad and Tobago' },
  { value: 'TN', label: 'Tunisia' },
  { value: 'TR', label: 'Turkey' },
  { value: 'TM', label: 'Turkmenistan' },
  { value: 'TC', label: 'Turks and Caicos Islands (the)' },
  { value: 'TV', label: 'Tuvalu' },
  { value: 'UG', label: 'Uganda' },
  { value: 'UA', label: 'Ukraine' },
  { value: 'AE', label: 'United Arab Emirates (the)' },
  {
    value: 'GB',
    label: 'United Kingdom of Great Britain and Northern Ireland (the)'
  },
  { value: 'UM', label: 'United States Minor Outlying Islands (the)' },
  { value: 'US', label: 'United States of America (the)' },
  { value: 'UY', label: 'Uruguay' },
  { value: 'UZ', label: 'Uzbekistan' },
  { value: 'VU', label: 'Vanuatu' },
  { value: 'VE', label: 'Venezuela (Bolivarian Republic of)' },
  { value: 'VN', label: 'Viet Nam' },
  { value: 'VG', label: 'Virgin Islands (British)' },
  { value: 'VI', label: 'Virgin Islands (U.S.)' },
  { value: 'WF', label: 'Wallis and Futuna' },
  { value: 'EH', label: 'Western Sahara' },
  { value: 'YE', label: 'Yemen' },
  { value: 'ZM', label: 'Zambia' },
  { value: 'ZW', label: 'Zimbabwe' },
  { value: 'AX', label: 'Åland Islands' }
];

export const owaspList = [
  { value: 41, label: 'A1: Broken Access Control' },
  { value: 42, label: 'A2: Cryptographic Failures' },
  { value: 43, label: 'A3: Injection' },
  { value: 44, label: 'A4: Insecure Design' },
  { value: 45, label: 'A5: Security Misconfiguration' },
  { value: 46, label: 'A6: Vulnerable and Outdated Components' },
  { value: 47, label: 'A7: Identification and Authentication Failures' },
  { value: 48, label: 'A8: Software and Data Integrity Failures' },
  { value: 49, label: 'A9: Security Logging and Monitoring Failures' },
  { value: 50, label: 'A10: Server-Side Request Forgery (SSRF)' }
];

export const prefixList = [
  { value: '<=', label: '≤ (Less than or equal)' },
  { value: '<', label: '< (Less than)' },
  { value: '', label: 'Specific version' }
];

export const vulnerabilityTypes = [
  { value: 1, label: 'SQL Injection', selected: false },
  { value: 2, label: 'Cross Site Scripting (XSS)', selected: false },
  { value: 3, label: 'Remote File Inclusion', selected: false },
  { value: 4, label: 'Local File Inclusion', selected: false },
  { value: 5, label: 'Session Hijacking', selected: false },
  { value: 6, label: 'Cross Site Request Forgery (CSRF)', selected: false },
  { value: 7, label: 'Open Redirection', selected: false },
  { value: 8, label: 'Bypass Vulnerability', selected: false },
  { value: 9, label: 'Multiple Vulnerabilities', selected: false },
  { value: 10, label: 'Unknown', selected: false },
  { value: 11, label: 'Arbitrary File Download', selected: false },
  { value: 12, label: 'Sensitive Data Exposure', selected: false },
  { value: 13, label: 'Arbitrary Code Execution', selected: false },
  { value: 14, label: 'Arbitrary File Upload', selected: false },
  { value: 15, label: 'Server Side Request Forgery (SSRF)', selected: false },
  { value: 16, label: 'Full Path Disclosure (FPD)', selected: false },
  { value: 17, label: 'Directory Traversal', selected: false },
  { value: 18, label: 'Denial of Service Attack', selected: false },
  { value: 19, label: 'Direct static code injection', selected: false },
  { value: 20, label: 'CRLF Injection', selected: false },
  { value: 21, label: 'PHP Object Injection', selected: false },
  { value: 22, label: 'XML External Entity (XXE)', selected: false },
  {
    value: 23,
    label: 'Insecure Direct Object References (IDOR)',
    selected: false
  },
  { value: 24, label: 'Remote Code Execution (RCE)', selected: false },
  { value: 25, label: 'Unvalidated Redirects and Forwards', selected: false },
  { value: 26, label: 'Privilege Escalation', selected: false },
  { value: 27, label: 'CSV Injection', selected: false },
  { value: 28, label: 'Deserialization of untrusted data', selected: false },
  { value: 29, label: 'Other Vulnerability Type', selected: false },
  { value: 30, label: 'Broken Authentication', selected: false },
  { value: 31, label: 'Arbitrary File Deletion', selected: false },
  { value: 32, label: 'Content Spoofing', selected: false },
  { value: 33, label: 'Clickjacking', selected: false },
  { value: 34, label: 'Enumeration', selected: false },
  { value: 35, label: 'Arbitrary Content Deletion', selected: false },
  { value: 36, label: 'Cross-Frame Scripting (XFS)', selected: false },
  { value: 37, label: 'Content Injection', selected: false },
  { value: 38, label: 'Backdoor', selected: false },
  { value: 39, label: 'Settings Change', selected: false },
  { value: 40, label: 'Broken Access Control', selected: false },
  { value: 41, label: 'Path Traversal', selected: false },
  { value: 42, label: 'Race Condition', selected: false }
];

export const generateTimezoneArray = () => {
  const timezonesRaw = Intl.supportedValuesOf('timeZone');

  const date = new Date();

  const timezoneCorrections = new Map([['Asia/Katmandu', 'Asia/Kathmandu']]);

  const formattedTimezones = timezonesRaw.map((timezone) => {
    const displayTimezone = timezoneCorrections.get(timezone) || timezone;

    const formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      timeZoneName: 'longOffset'
    });

    const formattedParts = formatter.formatToParts(date);
    const offsetPart = formattedParts.find(
      (part) => part.type === 'timeZoneName'
    );
    const offset = offsetPart ? offsetPart.value.replace('GMT', 'UTC') : '';

    return {
      value: displayTimezone,
      label: `${displayTimezone} (${offset})`
    };
  });

  return formattedTimezones.sort((a, b) => a.value.localeCompare(b.value));
};

const getVendorItems = () => [
  {
    label: 'Reports',
    to: '/vdp/reports/awaiting_fix',
    target: '_self',
    type: 'link'
  },
  { label: 'Programs', to: '/vdp/programs', target: '_self', type: 'link' },
  {
    label: 'AI code review',
    to: '/vdp/ai/code-review',
    target: '_self',
    type: 'link'
  },
  { label: 'Account', to: '/vdp/settings', target: '_self', type: 'link' }
];

export const getMobileResearcherItems = (uuid: string) => [
  {
    label: 'Reports',
    to: `/researchers/${uuid}`,
    target: '_self',
    type: 'link'
  },
  {
    label: 'Account',
    to: '/researchers/settings',
    target: '_self',
    type: 'link'
  },
  {
    label: 'Leaderboard',
    to: 'https://patchstack.com/database/leaderboard/',
    target: '_blank',
    type: 'link'
  },
  {
    label: 'Security programs',
    to: 'https://patchstack.com/database/vdp/?page=1',
    target: '_blank',
    type: 'link'
  },
  {
    label: 'Guidelines',
    to: 'https://patchstack.com/articles/bug-bounty-guidelines-rules/',
    target: '_blank',
    type: 'link'
  },
  {
    label: 'Database',
    to: 'https://patchstack.com/database/',
    target: '_blank',
    type: 'link'
  },
  {
    label: 'Discord',
    to: 'https://discord.com/invite/V9AE9zczhv',
    target: '_blank',
    type: 'link'
  }
];

export const getRegularResearcherItems = (uuid: string) => [
  {
    label: 'Reports',
    to: `/researchers/${uuid}`,
    type: 'link',
    target: '_self'
  },
  {
    label: 'Account',
    to: `/researchers/settings`,
    type: 'link',
    target: '_self'
  },
  {
    label: 'Resources',
    type: 'dropdown',
    dropdown: [
      {
        label: 'Leaderboard',
        to: 'https://patchstack.com/database/leaderboard/',
        target: '_blank'
      },
      {
        label: 'Security programs',
        to: 'https://patchstack.com/database/vdp/',
        target: '_blank'
      },
      {
        label: 'Guidelines',
        to: 'https://patchstack.com/articles/bug-bounty-guidelines-rules/',
        target: '_blank'
      },
      {
        label: 'Database',
        to: 'https://patchstack.com/database/',
        target: '_blank'
      },
      {
        label: 'Discord',
        to: 'https://discord.com/invite/V9AE9zczhv',
        target: '_blank'
      }
    ]
  }
];

const getRegularBaseItems = () => [
  {
    label: 'Pricing',
    to: 'https://patchstack.com/pricing/',
    type: 'link',
    target: '_blank'
  },
  {
    label: 'Solutions',
    type: 'dropdown',
    dropdown: [
      {
        label: 'WordPress security',
        to: 'https://patchstack.com/wordpress-security/',
        description: 'Instantly fix and mitigate vulnerabilities',
        target: '_blank'
      },
      {
        label: 'Plugin auditing',
        to: 'https://patchstack.com/auditing/',
        description: 'Paid auditing for WordPress vendors',
        target: '_blank'
      },
      {
        label: 'Managed VDP',
        to: 'https://patchstack.com/for-plugins/',
        description: 'Start a security program for your plugin',
        target: '_blank'
      },
      {
        label: 'Bug Bounty',
        to: 'https://patchstack.com/bug-bounty/',
        description: 'Join the community and earn bounties',
        target: '_blank'
      },
      {
        label: 'For hosts',
        to: 'https://patchstack.com/for-hosts/',
        description: 'At scale monitoring and vPatching for hosts',
        target: '_blank'
      },
      {
        label: 'Vulnerability database',
        to: 'https://patchstack.com/database/',
        description: 'The latest WordPress security intelligence',
        target: '_blank'
      }
    ]
  },
  {
    label: 'Login',
    to: 'https://app.patchstack.com/login',
    type: 'link',
    target: '_blank'
  }
];

const getBaseMobileItems = () => [
  {
    label: 'Pricing',
    to: 'https://patchstack.com/pricing/',
    target: '_blank'
  },
  {
    label: 'WordPress security',
    to: 'https://patchstack.com/wordpress-security/',
    target: '_blank'
  },
  {
    label: 'Plugin auditing',
    to: 'https://patchstack.com/auditing/',
    target: '_blank'
  },
  {
    label: 'Managed VDP',
    to: 'https://patchstack.com/for-plugins/',
    target: '_blank'
  },
  {
    label: 'Bug Bounty',
    to: 'https://patchstack.com/bug-bounty/',
    target: '_blank'
  },
  {
    label: 'For hosts',
    to: 'https://patchstack.com/for-hosts/',
    target: '_blank'
  },
  {
    label: 'Vulnerability database',
    to: 'https://patchstack.com/database/',
    target: '_blank'
  },
  { label: 'Login', to: 'https://app.patchstack.com/login', target: '_blank' }
];

export const baseMenuItems = {
  regular: getRegularBaseItems(),
  mobile: getBaseMobileItems()
};

export const vendorMenuItems = {
  regular: getVendorItems(),
  mobile: getVendorItems()
};

export const PAGE_LIMIT = 25;
export const ERROR_SEPARATOR = '_::_';
export const NOT_FOUND_ERROR = 404;
export const SERVER_ERROR = 500;
export const UNAUTHORIZED_ERROR = 401;
export const VALIDATION_ERROR = 422;

//subscription
export const FREE_PLAN = '0.00';
export const PREMIUM_PLAN = '75.00';
